import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/63/thumb-landscape.jpg"

const Post63 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">
        TOD’S／レザーバッグ マイクロ／W15 × H12 × D10 (cm)
      </span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <h2 className="sideline-title">冬の街に自然と溶け込む、大人の名品</h2>
          <p>1月は、年末年始の華やぎが落ち着き、装いにも「本当に良いもの」が求められる季節です。<br></br>
          ウールコートの質感、ニットのやわらかさ、落ち着いたトーンでまとめた冬のスタイル──<br></br>
          そんな装いを完成させる最後のピースがバッグです。</p>
          <p>「冬コーデにきちんと感をプラスしたい」<br></br>
          「コートに負けない上質なバッグが欲しい」<br></br>
          「流行に左右されず長く使える名品を選びたい」</p>
          <p>そんな大人の女性たちが、1月に選んでいるのがTOD’S（トッズ）のレザーバッグ。<br></br>
          ミニマルで洗練されたデザインは、重くなりがちな冬の装いに自然に馴染みながら、さりげなく“品の良さ”を引き立ててくれます。</p>
          <p>本記事では、冬のおしゃれが楽しくなる1月に向けて、「TOD’S（トッズ）のレザーバッグが選ばれる理由」や「定番7モデルのサイズ感や特徴の違い」など、大人の女性が「自分に合う一品」を見つけやすい視点でまとめています。</p>
          <p>冬バッグ選びのヒントとして、ぜひ参考にしてみてください。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;TOD’Sのバッグを支持している年齢層</ScrollLink><br></br>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;TOD’Sが冬に選ばれる“3つの理由”</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;控えめなのに「上質」</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;収納力・構造が優秀</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;大人の冬服に“合わせやすい”バランス設計</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;TOD’S「レザーバッグ」7モデル サイズ徹底比較</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ワンハンドルモデル_4タイプ（エレガント派に人気）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent-2" to="sec8" smooth={true} duration={500} offset={-80}>→&nbsp;&nbsp;マイクロ（縦長）／W14 × H16 × D8（cm）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent-2" to="sec9" smooth={true} duration={500} offset={-80}>→&nbsp;&nbsp;マイクロ（横長）／W24 × H16 × D14（cm）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent-2" to="sec10" smooth={true} duration={500} offset={-80}>→&nbsp;&nbsp;ミニ／W22 × H19 × D13（cm）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent-2" to="sec11" smooth={true} duration={500} offset={-80}>→&nbsp;&nbsp;ミディアム／W35 × H26 × D18（cm）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec12" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ダブルハンドルモデル_3タイプ（荷物が多い人に最適）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent-2" to="sec13" smooth={true} duration={500} offset={-80}>→&nbsp;&nbsp;マイクロ／W15 × H12 × D10（cm）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent-2" to="sec14" smooth={true} duration={500} offset={-80}>→&nbsp;&nbsp;ミニ／W25 × H19 × D16（cm）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent-2" to="sec15" smooth={true} duration={500} offset={-80}>→&nbsp;&nbsp;ミディアム／W37 × H26 × D18（cm）</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec16" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;1月におすすめの冬コーデ × TOD’S</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec17" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;友人と年始ランチコーデ｜レザーバッグ ミニ（ブラウン）</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec18" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;親族と年始食事会コーデ｜レザーバッグ マイクロ（ベージュ）</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec19" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;まとめ：1月こそ、TOD’Sのバッグが“ちょうど良い”</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/63/1.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>TOD’Sのバッグを支持している年齢層</h2>
        </div>
        <p>トッズのバッグは<b className="text-font-bolder">20代後半〜50代以上まで非常に幅広く支持</b>されています。<br></br>
        とくに以下の層の支持が顕著です。</p>
        <div className="text-img-cloumn-main mt4">
          <figure className="img-xs">
            <StaticImage src="../../images/posts/63/2.jpg" alt=""/>
          </figure>
          <div>
            <p>働き方やライフスタイルが大きく変化し、自分の価値観でモノを選ぶようになる世代です。トレンドだけで選ぶのではなく、「長く使えるか」「自分の立場や装いに合っているか」を意識し始めるタイミングでもあります。トッズの落ち着いたデザインと高い実用性は、そうした30代の感覚にフィットします。主張しすぎないのに、きちんと良いものだと伝わる“背伸びしすぎない上質さ”が、日常のスタイルを自然に引き上げてくれます。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main">
          <figure className="img-xs">
            <StaticImage src="../../images/posts/63/3.jpg" alt=""/>
          </figure>
          <div>
            <p>ファッションにおいても「量より質」を重視するようになり、長く愛用できる投資アイテムを求める層です。トッズは流行に左右されにくい普遍的なデザインが多く、毎年変わる冬のトレンドの中でも安心して持ち続けることができます。特にコートやジャケットなど冬の重厚な装いとの相性が良く、バッグがスタイリングの軸として機能します。一つ持っているだけで、全体の印象を整えてくれる存在です。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main">
          <figure className="img-xs">
            <StaticImage src="../../images/posts/63/4.jpg" alt=""/>
          </figure>
          <div>
            <p>華やかさよりも、落ち着きや品格を大切にする世代です。<br></br>
            トッズのバッグは派手な装飾に頼らず、仕立てやフォルムの美しさで存在感を放ちます。そのため、年齢を重ねたからこそ似合う“知的な余裕”を感じさせるアイテムとして支持されています。冬の装いにさりげなく寄り添い、スタイル全体を上品に格上げしてくれるのが魅力です。</p>
          </div>
        </div>
      </section>
      <section name="sec2" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/63/5.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>TOD’Sが冬に選ばれる“3つの理由”</h2>
        </div>
        <p>冬の装いが重くなりがちな1月。<br></br>
        そんな時期にトッズのバッグが支持されるのには、きちんとした理由があります。<br></br>
        デザイン、実用性、そして冬服との相性——<br></br>
        大人の女性が「これなら間違いない」と感じる3つのポイントを、順に見ていきましょう。</p>
        <div name="sec3" className="mt8">
          <div>
            <h3>◆ 控えめなのに「上質」</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/63/6.jpg" alt=""/>
            </figure>
            <div>
              <p>ロゴ主張が強くないため、コートやニット、ブーツといった重厚感のある冬のスタイルにも自然に馴染みます。</p>
              <p>それでいて、持ち手のカーブやフォルムの美しさによってさりげない存在感を放ち、全体の印象を引き締めてくれます。</p>
              <p>主張しすぎず、しかし確かな上質さを感じさせる、その絶妙なバランスこそがトッズの魅力です。</p>
            </div>
          </div>
        </div>
        <div name="sec4" className="mt8">
          <div>
            <h3>◆ 収納力・構造が優秀</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/63/7.jpg" alt=""/>
            </figure>
            <div>
              <p>とくにトッズの「レザーバッグ」シリーズは、細部のつくりが非常に丁寧です。</p>
              <p>ワンハンドルモデルは中央にファスナー仕切りがあり、荷物を整理しやすい設計です。</p>
              <p>ダブルハンドルモデルは内ポケットが充実しており、実用品としての完成度が高いのも特徴です。</p>
              <p>ショルダーストラップが付属しており、斜めがけにも対応します。</p>
              <p>バッグの口が大きく開きすぎないため、冬の厚手アイテムを入れても形が崩れにくく、美しいシルエットを保ちます。</p>
            </div>
          </div>
        </div>
        <div name="sec5" className="mt8">
          <div>
            <h3>◆ 大人の冬服に“合わせやすい”バランス設計</h3>
          </div>
          <div className="text-img-cloumn-main">
            <figure>
              <StaticImage src="../../images/posts/63/8.jpg" alt=""/>
            </figure>
            <div>
              <p>トッズのバッグは、単体での美しさだけでなく、着用したときの全身バランスまで計算されています。</p>
              <p>厚手のコートやボリュームのあるニットを着た際にも、バッグが主張しすぎず、スタイル全体をスマートにまとめてくれます。</p>
              <p>サイズ感やハンドルの位置、バッグの重心が絶妙なため、「冬服と合わせるとしっくりこない」という悩みが起こりにくいのも特徴です。</p>
              <p>大人の冬の装いに自然と溶け込み、コーディネートを完成させてくれる存在といえます。</p>
            </div>
          </div>
        </div>
        <div className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/9.jpg" alt=""/>
            <span className="text-center">TOD’S（トッズ）レザーバッグ<br></br>マイクロ：W15 × H12 × D10 (cm)／ミニ：W22 × H19 × D13 (cm)／マイクロ縦長：W14 × H16 × D8 (cm)</span>
          </figure>
        </div>
      </section>
      <section name="sec6" className="section-content">
        <div>
          <h2>TOD’S「レザーバッグ」7モデル サイズ徹底比較</h2>
        </div>
        <div name="sec7" className="mt4">
          <div>
            <h3>◆ ワンハンドルモデル_4タイプ（エレガント派に人気）</h3>
          </div>
          <div className="model-img-list-63">
            <figure>
              <StaticImage src="../../images/posts/63/10.jpg" alt=""/>
              <span className="text-center">マイクロ 縦型</span>
            </figure>
            <figure>
              <StaticImage src="../../images/posts/63/11.jpg" alt=""/>
              <span className="text-center">マイクロ 横型</span>
            </figure>
            <figure>
              <StaticImage src="../../images/posts/63/12.jpg" alt=""/>
              <span className="text-center">ミニ</span>
            </figure>
            <figure>
              <StaticImage src="../../images/posts/63/13.jpg" alt=""/>
              <span className="text-center">ミディアム</span>
            </figure>
          </div>
          <div className="table-rounded-bg">
            <div className="table-wrap">
              <table className="table-rounded">
                <thead>
                  <tr>
                    <th></th>
                    <th>サイズ (cm)</th>
                    <th>特徴</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>マイクロ 縦型</th>
                    <td>W14 × H16 × D8</td>
                    <td>
                      <p>・ストラップあり（取り外し可能）<br></br>
                      ・ポケット付き仕切りあり</p>
                    </td>
                  </tr>
                  <tr>
                    <th>マイクロ 横型</th>
                    <td>W24 × H16 × D14</td>
                    <td>
                      <p>・ストラップあり（取り外し可能）<br></br>
                      ・ファスナー付きポケットあり</p>
                    </td>
                  </tr>
                  <tr>
                    <th>ミニ</th>
                    <td>W22 × H19 × D13</td>
                    <td>
                      <p>・ストラップあり（取り外し可能）<br></br>
                      ・ファスナー付きポケットあり</p>
                    </td>
                  </tr>
                  <tr>
                    <th>ミディアム</th>
                    <td>W35 × H26 × D18</td>
                    <td>
                      <p>・ファスナー付きポケットあり<br></br>
                      ・仕切りあり</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div name="sec8" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/14.jpg" alt=""/>
          </figure>
          <div>
            <h4>1. マイクロ（縦長）／W14 × H16 × D8 (cm)</h4>
          </div>
          <p>最もコンパクトなモデルで、<b className="text-font-bolder">ミニバッグ派さんにおすすめ</b>です。<br></br>
            縦長フォルムはスマホやミニ財布、リップなど最低限のものがすっきり収まり、冬コーデのアクセントとしても軽やかに映えます。
          </p>
          <p>冬の街歩きやカフェ巡り、イベントシーンにも◎。</p>
          <p>厚手のコートと合わせてもバランスが取りやすく、“小さくても品のあるバッグ”を求める方にぴったりです。</p>
        </div>
        <div name="sec9" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/15.jpg" alt=""/>
          </figure>
          <div>
            <h4>2. マイクロ（横長）／W24 × H16 × D14 (cm)</h4>
          </div>
          <p>横方向に幅があり、<b className="text-font-bolder">収納力とコンパクトさを両立</b>した贅沢なサイズ。</p>
          <p>スマホ・長財布・ハンカチ・手袋など、冬に必要な小物をしっかり入れられます。<br></br>
          バッグ内部には仕切りや小ポケットがあり整理もしやすいので、「小さくても機能性は妥協したくない！」という方におすすめです。</p>
          <p>また、横長シルエットはクラシックな雰囲気を引き立て、冬コートと相性抜群です。</p>
        </div>
        <div name="sec10" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/16.jpg" alt=""/>
          </figure>
          <div>
            <h4>3. ミニ／W22 × H19 × D13 (cm)</h4>
          </div>
          <p>トッズの定番人気サイズです。<br></br>
          コンパクトながら収納力があり、デイリーからお出かけまで<b className="text-font-bolder">使い勝手が良い</b>のが魅力。</p>
          <p>冬の必需品である手袋・ポケットティッシュ・ミニ財布・スマホがほどよく収まります。<br></br>
          ショルダーストラップ付きで、肩掛け・斜め掛けにも対応します。</p>
          <p>冬のデートや街歩きに最も使われるサイズとして、多くのファッションエディターからも支持されています。</p>
        </div>
        <div name="sec11" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/17.jpg" alt=""/>
          </figure>
          <div>
            <h4>4. ミディアム／W35 × H26 × D18 (cm)</h4>
          </div>
          <p>一気に実用性がアップする<b className="text-font-bolder">万能サイズ</b>です。<br></br>
          A4サイズの書類やタブレットも収納できるため、通勤バッグとしても大活躍します。</p>
          <p>冬は厚手の手袋・マフラー・折りたたみ傘・ポーチと何かと荷物が増えるもの。</p>
          <p>このミディアムサイズなら、荷物を入れても型崩れせず、バッグのフォルムを保てるのが嬉しいポイントです。</p>
          <p>オンオフ両方で使える、“働く大人の冬バッグ”として特に人気があります。</p>
        </div>
        <div name="sec12" className="mt8">
          <div>
            <h3>◆ ダブルハンドルモデル_3タイプ（荷物が多い人に最適）</h3>
          </div>
          <div className="model-img-list-63">
            <figure>
              <StaticImage src="../../images/posts/63/18.jpg" alt=""/>
              <span className="text-center">マイクロ</span>
            </figure>
            <figure>
              <StaticImage src="../../images/posts/63/19.jpg" alt=""/>
              <span className="text-center">ミニ</span>
            </figure>
            <figure>
              <StaticImage src="../../images/posts/63/20.jpg" alt=""/>
              <span className="text-center">ミディアム</span>
            </figure>
          </div>
          <div className="table-rounded-bg">
            <div className="table-wrap">
              <table className="table-rounded">
                <thead>
                  <tr>
                    <th></th>
                    <th>サイズ (cm)</th>
                    <th>特徴</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>マイクロ</th>
                    <td>W15 × H12 × D10</td>
                    <td>
                      <p>・ストラップあり（取り外し可能）<br></br>
                      ・ファスナーなし<br></br>
                      ・ポケット仕切り×2</p>
                    </td>
                  </tr>
                  <tr>
                    <th>ミニ</th>
                    <td>W25 × H19 × D16</td>
                    <td>
                      <p>・ストラップあり（取り外し可能）<br></br>
                      ・ファスナー付き<br></br>
                      ・ポケット仕切り×2</p>
                    </td>
                  </tr>
                  <tr>
                    <th>ミディアム</th>
                    <td>W37 × H26 × D18</td>
                    <td>
                      <p>・ファスナー付き<br></br>
                      ・ポケット仕切り×2</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div name="sec13" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/21.jpg" alt=""/>
          </figure>
          <div>
            <h4>5. マイクロ／W15 × H12 × D10 (cm)</h4>
          </div>
          <p>ダブルハンドル特有のしっかりした<b className="text-font-bolder">“持ち感”が魅力</b>の、小さめハンドバッグです。<br></br>
            小物だけ持ちたい日や、ちょっとしたお出かけ用の2つ目バッグとして重宝します。
          </p>
          <p>冬のブーツやニットと合わせてもバランスが取りやすく、コンパクトながらも上品なフォルムが全体を引き締めます。</p>
          <p>クラッチ感覚でも使えるため、夜のディナーやイベントにもおすすめです。</p>
        </div>
        <div name="sec14" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/22.jpg" alt=""/>
          </figure>
          <div>
            <h4>6. ミニ／W25 × H19 × D16 (cm)</h4>
          </div>
          <p>ワンハンドルのミニと比べるとやや容量が大きく、内ポケットが充実しているため、<b className="text-font-bolder">整理整頓しながら収納したい方に最適</b>です。</p>
          <p>財布・スマホ・手袋・ミニポーチなど冬の日常アイテムをラクに収められ、ダブルハンドルの安定感で肩にかけてもストレスがありません。</p>
          <p>通勤でも休日でも使える“ちょうど良さ”が人気の理由です。</p>
        </div>
        <div name="sec15" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/23.jpg" alt=""/>
          </figure>
          <div>
            <h4>7. ミディアム／W37 × H26 × D18 (cm)</h4>
          </div>
          <p>シリーズ最大サイズで、<b className="text-font-bolder">A4対応＆収納力抜群</b>の使い勝手。</p>
          <p>冬は衣類が重くなりがちですが、このミディアムなら余裕の容量でノートPC・ブランケット・手袋・ポーチなどをまとめて収納できます。</p>
          <p>ハンドルがしっかりしているため持ちやすく、ダブルハンドルならではの安心感あるフォルムでビジネスシーンにも最適です。</p>
          <p>“冬の頼れるバッグ”として、特に通勤・出張シーンで好評です。</p>
        </div>
      </section>
      <section name="sec16" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/63/24.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>1月におすすめの冬コーデ × TOD’S</h2>
        </div>
        <p>新年の予定が増える1月は、シーンに合わせた“きちんと感”と“抜け感”のバランスが鍵です。<br></br>
        トッズのバッグを主役に、年始にちょうどいい大人の冬コーデをご紹介します。</p>
        <div name="sec17" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/25.jpg" alt=""/>
            <span className="text-center">TOD’S／レザーバッグ ミニ／W22 × H19 × D13 (cm)</span>
          </figure>
          <div className="mt8">
            <h3>◆ 友人と年始ランチコーデ｜レザーバッグ ミニ（ブラウン）</h3>
          </div>
          <p>“肩の力を抜いた大人カジュアル”がちょうどいいバランス。</p>
          <p>友人との年始ランチは、きちんとしすぎず、でもラフすぎない装いが理想です。<br></br>
          ワンハンドルのミニサイズ（ブラウン）は、そんなシーンにぴったりの存在感を放ちます。</p>
          <p>フーディーにショート丈のムートンジャケットを重ねた、程よく力の抜けた冬カジュアル。<br></br>
          落ち感のあるワイドパンツとスニーカーで動きやすさを意識しつつ、ブラウンのトッズレザーバッグがコーデ全体を上品に引き締めます。</p>
          <p>カジュアルな場でも“大人らしさ”を忘れない、年始のランチに最適な装いです。</p>
        </div>
        <div name="sec18" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/63/26.jpg" alt=""/>
            <span className="text-center">TOD’S／レザーバッグ マイクロ／W15 × H12 × D10 (cm)</span>
          </figure>
          <div className="mt8">
            <h3>◆ 親族と年始食事会コーデ｜レザーバッグ マイクロ（ベージュ）</h3>
          </div>
          <p>控えめで上品、“きちんと感”を意識した大人の装い。</p>
          <p>親族との年始食事会では、華美になりすぎず、上質さが伝わるスタイルを意識したいところです。<br></br>
          そんな場面で活躍するのが、ダブルハンドのマイクロサイズです。</p>
          <p>明るいニットワンピースにグレージュのロングコートを合わせた、柔らかく上品なスタイル。<br></br>
          ホワイトブーツで軽さを出しつつ、ベージュのマイクロバッグで全体を端正にまとめています。</p>
          <p>控えめながらきちんと感があり、親族との食事会に安心して選べるコーデです。</p>
        </div>
      </section>
      <section name="sec19" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/63/27.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>まとめ：1月こそ、TOD’Sのバッグが“ちょうど良い”</h2>
        </div>
        <p>年末年始の華やぎがひと段落し、装いにも“本質”が求められる1月。<br></br>
        そんな時期にこそ選びたいのが、TOD’S（トッズ）のレザーバッグです。</p>
        <p>控えめでありながら確かな上質さを感じさせるデザイン、<br></br>
        冬の装いに負けない端正なフォルム、<br></br>
        そして日常使いに寄り添う高い実用性です。</p>
        <p>トレンドを追いすぎることなく、<br></br>
        それでいて今の自分にしっくりくる——<br></br>
        トッズのバッグは、大人の女性のライフスタイルに自然と馴染みます。</p>
        <p>サイズやモデルによって表情が変わる7つのラインナップは、通勤、休日、年始の集まりなど、1月のさまざまなシーンに対応しています。<br></br>
        「この冬、どんなバッグを持つか迷っている」という方にとって、長く愛せる一品に出会える選択肢となるはずです。</p>
        <p>新しい年の始まりに、自分らしい上質を。<br></br>
        1月の装いに、トッズのレザーバッグを取り入れてみてはいかがでしょうか。</p>
        <p className="mt4"><span className="text-border-bottom">TOD’S（トッズ）のレザーバッグはどこで借りられる？</span></p>
        <p>価格も高額で、簡単には手に取りにくいトッズのバッグ。<br></br>
        「試してみたいけれど、買うには勇気がいる」──そんな方におすすめなのが、ブランドバッグシェアリングサービス「ラクサス」です。<br></br>
        アプリで簡単に注文でき、自宅にいながら憧れのブランドバッグを楽しめます。</p>
        <div className="border"></div>
        <p>📱憧れを日常に──ラクサスでトッズを体験しよう！</p>     
        <Link to="https://laxus.co/app/pc/bags/tods" className="view-all-button">トッズのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post63

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 63}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`